import { Component, OnInit, OnDestroy, AfterViewChecked, ViewChildren, QueryList, ViewEncapsulation } from '@angular/core';
import { TopicLeaf } from '../../model/TopicLeaf';
import { CoursewareService } from '../../services/CoursewareService';
import { ContentEntryDisplayData } from '../../model/ContentEntry/ContentEntryDisplayData';
import { Router, ActivatedRoute } from '@angular/router';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';
import { LazyImagesComponent } from '../shared/lazy-images-component';

@Component({
  selector: 'app-short-videos',
  templateUrl: './short-videos.component.html',
  styleUrls: ['./short-videos.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ShortVideosComponent extends LazyImagesComponent implements OnInit, OnDestroy {
  public shortVideos: TopicLeaf[];
  public static cacheShortVideos: TopicLeaf[];
  public currentTopic: TopicLeaf = null;
  showTopics: boolean = true;
  showContentEntries: boolean = false;
  public currentContentEntry: ContentEntryDisplayData;
  public breadcrumbs: Breadcrumb[] = [];
  public topicArea: string = "/shortvideosview";
  public contentArea: string = "/shortvideoscontentview";

  constructor(private canonicalService: MetaService, private titleService: Title, private _router: Router, private route: ActivatedRoute, private coursewareService: CoursewareService, private alertService: AlertService) {
    super();
    this.getShortVideos();
    this.titleService.setTitle("Short Videos - LawShelf Educational Media");
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }


  getShortVideos() {
    if (!ShortVideosComponent.cacheShortVideos)
      this.coursewareService.getShortVideos().subscribe(data => {
        this.shortVideos = ShortVideosComponent.cacheShortVideos = data;
        if (!this.shortVideos || !this.shortVideos.length) {
          ShortVideosComponent.cacheShortVideos = this.shortVideos = null;
          let error: Error = data;
          this.alertService.error(error.Message);
        }
        this.initialize();
      });
    else {
      this.shortVideos = ShortVideosComponent.cacheShortVideos;
      this.initialize();
    }
  }

  hasShortVideos() {
    if (!this.shortVideos || this.shortVideos.length < 1)
      return false;
    return true;
  }

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.pushAllAds(2);
    let alias = this.route.snapshot.paramMap.get('alias');
    if (!alias) {
      this.currentTopic = null;
      this.showTopics = true;
      this.showContentEntries = false;
      this.breadcrumbs = null;
      this.canonicalService.createCanonicalURL(this._router.url, "/shortvideosview/");
      if (this.shortVideos)
        this.totalImages = this.shortVideos.length;

    } else {
      this.showTopics = false;
      this.showContentEntries = true;
      if (this.shortVideos) {
        for (let shortVideo of this.shortVideos) {
          if (shortVideo.TopicInformation.Alias == alias) {
            this.currentTopic = shortVideo;
            this.totalImages = this.currentTopic.contentEntries.length;
          }
        }
      }
      if (this.shortVideos && this.shortVideos.length && this.currentTopic == null)
        this.alertService.error("Error - could not find videos belonging to " + alias);
      if (this.currentTopic) {
        this.breadcrumbs = [{ Title: "Short-Videos", URL: "/shortvideosview" }, { Title: this.currentTopic.TopicInformation.Title, URL: "/shortvideosview/" + alias }];
        this.canonicalService.createCanonicalURL(this._router.url, "/shortvideosview/" + alias);
      }
    }
    this.loadLazyImages();
  }
}